import { useCallback, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";
import useApi from "../../services/api";
import { UpdateUser } from "../../store/reducers/auth.reducer";

import Template from "../../template/template";
import UserInfo from "./userInfo/userInfo";
import Notify from "../../components/notification/notify";
import SlotMachine from "../../components/slotMachine/slotMachine";
import { getRandomArrayItem } from "../../utils/getRandomArrayItem";

function DailyDraw() {
  initPage({ title: t("DailyDraw.Title") });

  const {
    user: { loyal_member_points },
  } = useSelector((store) => store.auth);
  const dispatch = useDispatch();
  const { ApiDailyDrawCanPlay, ApiDailyDrawResult, ApiGetUser, ApiGetLastWinners } = useApi();
  const items = useMemo(
    () => [
      {
        id: 1,
        credits: 5,
        icon: "/images/icone_cupons.png",
      },
      {
        id: 2,
        credits: 10,
        icon: "/images/icone_loyalmember.png",
      },
      {
        id: 3,
        credits: 20,
        icon: "/images/icone_creditos.png",
      },
    ],
    [],
  );
  const imagesItems = useMemo(() => items.map((item) => item.icon), [items]);
  const initialItems = useMemo(
    () => ["/images/icone_pergunta.png", "/images/icone_pergunta.png", "/images/icone_pergunta.png"],
    [],
  );
  const [winners, setWinners] = useState([]);
  const [iWinner, setIWinner] = useState(0);

  const getLastWinners = useCallback(async () => {
    const { data } = await ApiGetLastWinners();

    setWinners(data.lastWinners);
    setIWinner(data.iWinner);
  }, [ApiGetLastWinners]);

  useEffect(() => {
    getLastWinners();
  }, [getLastWinners]);

  const canPlay = useCallback(async () => {
    const { data } = await ApiDailyDrawCanPlay();

    if (!data.play) {
      Notify({ type: "danger", message: t("Errors.CantPlayDailyDrawn") });
      return false;
    }

    return true;
  }, [ApiDailyDrawCanPlay]);

  const onWin = useCallback(
    async (reward) => {
      if (reward) {
        Notify({
          type: "success",
          message: t("Success.DailyDrawWin", {
            credits: reward,
          }),
        });

        const { data } = await ApiGetUser();

        dispatch(UpdateUser(data));
      }
    },
    [ApiGetUser, dispatch],
  );

  const result = useCallback(async () => {
    const { data } = await ApiDailyDrawResult();

    const { result } = data;

    const icons = result.map((id) => {
      const item = items.find((currentItem) => currentItem.id === id);
      return item.icon;
    });

    return { ...data, icons };
  }, [ApiDailyDrawResult, items]);

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="loyal-member-warp">
              {/* loyal-member-warp */}
              <div className="loyal-sidebar">
                <div className="mobile-side-btn">
                  <button type="button" className="side-toggle">
                    <i className="fal fa-cog"></i>
                  </button>
                </div>
                <div className="loyal-sideinner-main">
                  <span className="mb-bg-cover view-below990"></span>
                  <div className="loyal-sideinner">
                    <div className="loyal-close-side view-below990">
                      <button type="button" className="side-toggle-close">
                        <i className="fal fa-cog"></i>
                      </button>
                    </div>
                    <div className="side-bar-top">
                      <div className="side-bar-top-max">
                        <div className="top-header gutter-40">
                          <h2 className="text-uppercase">
                            <img src="/images/crown-large.png" alt="" />
                            {t("LoyalMember.Title")}
                          </h2>
                        </div>
                        <UserInfo />
                      </div>
                    </div>
                    <div className="sortieo-data gutter-40">
                      <h2>
                        <span className="icon">
                          <img src="/images/sorteio-ico.png" alt="" />
                        </span>
                        {t("DailyDraw.Draw")}
                      </h2>
                      <ul>
                        <li>
                          {t("DailyDraw.MyPrizes")} <span>{iWinner}</span>
                        </li>
                        <li>
                          {t("DailyDraw.MyPoints")} <span>{loyal_member_points}</span>
                        </li>
                      </ul>
                    </div>
                    <div className="sortieo-data gutter-40">
                      <h2>
                        <span className="icon">
                          <img src="/images/doller-ico-lg.png" alt="" />
                        </span>
                        {t("DailyDraw.Recharge")}
                      </h2>
                      <ul>
                        <li>
                          <Link to={DefRoutes.RechargeCenter}>{t("DailyDraw.Cupons")}</Link>
                        </li>
                        <li>
                          <Link to={DefRoutes.RechargeCredit}>{t("DailyDraw.Credits")}</Link>
                        </li>
                        <li>
                          <Link to={DefRoutes.RechargeLoyalMember}>{t("DailyDraw.LoyalMember")}</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="loyal-contentwarp">
                <div className="loyal-contentinner">
                  <div className="content-hero">
                    <img src="/images/sorteio-hero1.png" alt="" />
                    <div className="sorteio-rolling-game">
                      <SlotMachine
                        initialItems={initialItems}
                        items={imagesItems}
                        canPlay={canPlay}
                        onWin={onWin}
                        result={result}
                      />
                    </div>
                  </div>

                  <div className="sorteio-content-warp">
                    <div className="sorteio-box-red">
                      <p>{t("DailyDraw.Description")}</p>
                      <figure>
                        <img src="/images/girl-ct.png" alt="" />
                      </figure>
                    </div>
                    <div className="sorteio-box-cream">
                      <h5>{t("DailyDraw.LastWinners")}s</h5>
                      <ul>
                        {winners.map((w, index) => {
                          return (
                            <li key={index}>
                              {w.user} - {w.prize} {t("General.Credits")}
                            </li>
                          );
                        })}
                      </ul>
                      <figure>
                        <img src="/images/star-shap-ct.png" alt="" />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>

              {/* loyal-member-warp */}
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default DailyDraw;
